<!-- Possible made easier by using forms: https://claude.ai/chat/e9dcf31c-cf93-4f35-9b8d-dc3a1140df58 -->
<template>
    <v-container>
        <v-row>
            <v-col class="ml-4" cols="12">

                <v-form  @submit.prevent="handleSubmit" ref="form">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="firstName"
                                    :counter="10"
                                    :rules="nameRules"
                                    :label="$t('psychologistSettings.first_name')"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="lastName"
                                    :counter="10"
                                    :rules="nameRules"
                                    :label="$t('psychologistSettings.last_name')"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    :items="languages"
                                    item-title="text"
                                    item-value="code"
                                    v-model="language"
                                    :rules="languageRules"
                                    :label="$t('psychologistSettings.language')"
                                    required
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-btn class="mt-2" type="submit" block>{{ $t('psychologistSettings.update') }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>

            </v-col>
        </v-row>        
    </v-container>
</template>

<script>
import apiService from '@/services/ApiService'

export default {
    name: 'PsychologistSettingsView',

    data() {
        return {
            loading: true,
            firstName: '',
            lastName: '',
            nameRules: [
                value => {
                    if (value) return true;
                    return this.$t('psychologistSettings.name_is_required')
                },
                value => {
                    if (value?.length >= 4) return true;
                    return this.$t('psychologistSettings.name_must_be_less_than_4_characters')
                },
            ],
            languageRules: [
                value => {
                    if (value) return true;
                    return this.$t('psychologistSettings.language_is_required')
                },
            ],
            language: null,
            languages: [
                { text: this.$t('languages.english'), code: 'en' },
                { text: this.$t('languages.romanian'), code: 'ro' },
            ]
        };
    },    

    async created() {
        // this.store.initAuth();        
    },

    async mounted(){
        this.firstName = this.store.user.firstName 
        this.lastName = this.store.user.lastName 
        this.language = this.store.user.language || 'en'
    },


    methods: {
        async updateLanguage(newLang){
            // Save to local storage and update i18n
            localStorage.setItem('user-language', newLang);
            this.$i18n.locale = newLang;
        },

        async updateProfile(){
            try {
                let profileData = {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    language: this.language
                }
                let psychologist = await apiService.updateProfile(profileData)
                console.log('PsychologistSettingsView > updateProfile > Response:', psychologist);

                /*NOTE: 
                    As token contains the user ID and email, if email is changed
                    we need to re-generate the token                
                    //let {token} = await apiService.refreshToken();
                    // this.store.login(token);
                */
                this.store.setUser(psychologist);
                await this.updateLanguage(this.language);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading = false;
            }
        },
        

        async handleSubmit(){
            // Validate form
            const { valid } = await this.$refs.form.validate()

            if (valid) {
                // Process form submission
                console.log('PsychologistSettingsView > handleSubmit >  Form is valid, submitting...')

                await this.updateProfile();

                this.$toast.success(this.$t('psychologistSettings.settings_updated'))
            }
            else{
                this.$toast.error(this.$t('psychologistSettings.form_contains_errors'))
            }
        }
    },
}
</script>

<style scoped></style>